/* global $ */
import React, { useState, useEffect, useRef } from "react";
import { NavLink } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../assets/css/swiper.min.css";
import rightArrow from "../assets/images/rightarw-svg.svg";
import { homeBaner } from "../Adapter/HomePageAdapter";
import { baseImage_path } from "../variables/Variables";
import BannerHome from "../assets/images/home-background.png";

const HeroSlider = () => {
    const [banners, setBanners] = useState([]); // Stores API data
    const [loading, setLoading] = useState(true); // Loading state
    const [error, setError] = useState(null); // Error state

    const prevRef = useRef(null);
    const nextRef = useRef(null);

    // Fetch the banner data on component mount
    useEffect(() => {
        const fetchBannerData = async () => {
            try {
                const response = await homeBaner();
                console.log("Banner API Response:", response);
                if (response && response.data) {
                    setBanners(response.data); // Set banner data
                } else {
                    setError("Failed to load banners.");
                }
            } catch (err) {
                setError("An error occurred while fetching banners.");
            } finally {
                setLoading(false); // Stop loading
            }
        };

        fetchBannerData();
    }, []);

    // Adjusting the Swiper initialization process
    useEffect(() => {
        const initSwiperNavigation = () => {
            if (prevRef.current && nextRef.current) {
                const swiperInstance = document.querySelector(".swiper").swiper;
                if (swiperInstance) {
                    swiperInstance.params.navigation.prevEl = prevRef.current;
                    swiperInstance.params.navigation.nextEl = nextRef.current;
                    swiperInstance.navigation.init();
                    swiperInstance.navigation.update();
                }
            }
        };

        // Delay the initialization slightly to ensure the refs are available
        const timer = setTimeout(initSwiperNavigation, 100);

        return () => clearTimeout(timer);
    }, [banners]);

    // Handle loading state
    if (loading) {
        return <div>Loading banners...</div>;
    }

    // Handle error state
    if (error) {
        return <div>{error}</div>;
    }

    return (
        // <section className="home-carousel-sec">
        //     <Swiper
        //         modules={[Navigation, Autoplay, Pagination]}
        //         loop
        //         spaceBetween={5}
        //         autoplay={{ delay: 50000 }}
        //         pagination={{
        //             enabled: true,
        //             el: ".swiper-pagination",
        //             dynamicBullets: false,
        //             clickable: true,
        //         }}
        //         navigation={{
        //             prevEl: prevRef.current,
        //             nextEl: nextRef.current,
        //             enabled: true,
        //             clickable: true,
        //         }}
        //         breakpoints={{
        //             767: {
        //                 slidesPerView: 1,
        //                 navigation: {
        //                     enabled: false,
        //                     prevEl: prevRef.current,
        //                     nextEl: nextRef.current,
        //                     clickable: true,
        //                 },
        //                 pagination: {
        //                     enabled: true,
        //                     el: ".swiper-pagination",
        //                     dynamicBullets: false,
        //                     clickable: true,
        //                 }
        //             },
        //             1024: {
        //                 slidesPerView: 1,
        //                 navigation: {
        //                     enabled: false,
        //                     prevEl: prevRef.current,
        //                     nextEl: nextRef.current,
        //                     clickable: true,
        //                 },
        //                 pagination: {
        //                     enabled: true,
        //                     el: ".swiper-pagination",
        //                     dynamicBullets: true,
        //                     clickable: true,
        //                 }
        //             }
        //         }}
        //         onBeforeInit={(swiper) => {
        //             swiper.params.navigation.prevEl = prevRef.current;
        //             swiper.params.navigation.nextEl = nextRef.current;
        //             swiper.navigation.init();
        //             swiper.navigation.update();
        //         }}

        //     >
        //         {banners.map((banner) => (
        //             <SwiperSlide key={banner.id}>
        //                 <div className="home-ban-item">
        //                     <picture>
        //                         <source
        //                             media="(min-width:676px)"
        //                             srcSet={banner.img_path ? `${baseImage_path}/${banner.img_path.replace(/^\.\/?/, "")}` : ""}
        //                             onError={(e) => (e.target.srcSet = "/assets/images/BannerHome.png")} // Fallback image
        //                         />
        //                         <img
        //                             src={banner.mob_img ? `${baseImage_path}${banner.mob_img.replace(/^\.\/?/, "")}` : `${baseImage_path}${banner.img_path.replace(/^\.\/?/, "")}`}
        //                             alt="Banner"
        //                             onError={(e) => (e.target.src = "/assets/images/BannerHome.png")} // Fallback image
        //                         />
        //                     </picture>

        //                     <div className="safe-card">
        //                         <h1>{banner.banner_heading} <br />
        //                         </h1>
        //                         <p>{banner.banner_sub_heading}</p>
        //                         <NavLink to="/about" className="btn with-color with-arr">
        //                             <img src={rightArrow} alt="arrow" /> Learn More
        //                         </NavLink>
        //                     </div>
        //                 </div>
        //             </SwiperSlide>

        //         ))}
        //     </Swiper>

        //     <div className="navbox" style={{ cursor: "pointer" }}>
        //         <div className="homeban-naviga">
        //             <span className="swiper-pagination"></span>
        //         </div>
        //         <p ref={prevRef} className="swiper-cust-prev">
        //             <span>&lt;</span>
        //         </p>
        //         <p ref={nextRef} className="swiper-cust-next">
        //             <span>&gt;</span>
        //         </p>
        //     </div>
        // </section>
        <section className="home-carousel-sec">
            {banners.length > 0 && (
                <div className="home-ban-item">
                    <picture>
                        <source
                            media="(min-width:676px)"
                            srcSet={
                                banners[0].img_path
                                    ? `${baseImage_path}/${banners[0].img_path.replace(/^\.\/?/, "")}`
                                    : BannerHome
                            }
                            onError={(e) => (e.target.srcSet = BannerHome)}
                        />
                        <img
                            src={
                                banners[0].mob_img
                                    ? `${baseImage_path}${banners[0].mob_img.replace(/^\.\/?/, "")}`
                                    : banners[0].img_path
                                        ? `${baseImage_path}${banners[0].img_path.replace(/^\.\/?/, "")}`
                                        : BannerHome
                            }
                            alt="Banner"
                            onError={(e) => (e.target.src = BannerHome)}
                        />
                    </picture>

                    <div className="safe-card">
                        <h1>
                            {banners[0].banner_heading}
                        </h1>
                        <p>{banners[0].banner_sub_heading}</p>
                        <NavLink to="/about-us" className="btn with-color with-arr">
                            <img src={rightArrow} alt="arrow" /> Learn More
                        </NavLink>
                    </div>
                </div>
            )}
        </section>
    );
};

export default HeroSlider;
